export default __webpack_public_path__ + "static/media/payjak-logotype-d.ef0d9d53.svg";